module.exports = __webpack_public_path__ + "static/media/07_peru21.8ad34e69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/scrap-step/press/07_peru21.png
// module id = 542
// module chunks = 0